/* ═══════════════════════════════════════════════════
   Great Escape Outdoors — global.js
   Shopify Theme Asset: assets/global.js
   ═══════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function () {

  /* ─── Nav scroll behaviour ─── */
  const nav = document.getElementById('main-nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    });
  }

  /* ─── Meal selector (variant selector UX) ─── */
  document.querySelectorAll('.meal-item').forEach(item => {
    item.addEventListener('click', () => {
      document.querySelectorAll('.meal-item').forEach(i => i.classList.remove('active'));
      item.classList.add('active');
    });
  });

  /* ─── Add to Cart — Shopify AJAX Cart API ─── */
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const orig = this.textContent;
      this.textContent = 'Adding...';
      this.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(r => r.json())
        .then(() => {
          this.textContent = '✓ Added!';
          this.style.cssText = 'background:var(--sage);color:var(--cream);border-color:var(--sage);';
          /* Update cart count */
          return fetch('/cart.js');
        })
        .then(r => r.json())
        .then(cart => {
          const cartCount = document.querySelector('.cart-count');
          if (cartCount) cartCount.textContent = cart.item_count;
          setTimeout(() => {
            this.textContent = orig;
            this.style.cssText = '';
            this.disabled = false;
          }, 1600);
        })
        .catch(() => {
          this.textContent = orig;
          this.style.cssText = '';
          this.disabled = false;
        });
    });
  });

  /* ─── Smooth anchor scroll ─── */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const t = document.querySelector(a.getAttribute('href'));
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

  /* ─── Intersection Observer scroll-in animations ─── */
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.opacity = '1';
        e.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.product-card, .essential-item, .testi-card, .cat-tile, .gallery-item, .trust-item').forEach(el => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(24px)';
    el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(el);
  });

  /* ─── Video fallback: if video fails show poster ─── */
  document.querySelectorAll('video').forEach(video => {
    video.addEventListener('error', function () {
      this.style.display = 'none';
    });
    video.play().catch(() => { /* autoplay blocked — poster already showing */ });
  });

  /* ─── Newsletter form success state ─── */
  const newsletterForm = document.getElementById('newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      /* Shopify handles the actual submission — this just shows UI feedback */
      const successMsg = document.querySelector('.newsletter-success');
      if (successMsg) {
        setTimeout(() => { successMsg.style.display = 'block'; }, 500);
      }
    });
  }

});
wrapper.style.transform = `translateX(-${index * 100}%)`;